// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"YouTubeIframeVideo_bodyWrapper__3Nqsi","body":"YouTubeIframeVideo_body__3fco2"};